import { Bar } from "react-chartjs-2";
import "chart.js/auto";
import { getColorByValue } from "../../../helpers/utils";
import { useTranslation } from "react-i18next";
import { Average } from "../../../types/chartData";
import { ChartOptions } from "chart.js/auto";
import { forwardRef } from "react";
import { ChartJSOrUndefined } from "react-chartjs-2/dist/types";

type OverallBarChartProps = {
  average: Average | null;
  height: string | number;
  selection?: string;
  attribute: string;
  onRendered?: () => void;
  selectAll? : boolean;
};

const OverallBarChart = forwardRef<
  ChartJSOrUndefined<"bar", number[], string> | undefined,
  OverallBarChartProps
>(({ average, height, selection, attribute, onRendered, selectAll = false }, ref) => {
  const { t } = useTranslation();

  if (!average) {
    average = { mli: 0, pain: 0 };
  }
  const data = {
    labels: ["MLI", t("pain")],
    datasets: [
      {
        label: "", // Keep this empty if you don't want labels
        data: [average.mli, average.pain],
        backgroundColor: [
          getColorByValue(average.mli, "MLI", attribute === "MLI", selectAll),
          getColorByValue(average.pain, "pain", attribute === t("pain"), selectAll),
        ],
        borderColor: [
          getColorByValue(average.mli, "MLI", attribute === "MLI",selectAll),
          getColorByValue(average.pain, "pain", attribute === t("pain"),selectAll),
        ],
        borderWidth: 1,
      },
    ],
  };

  const options: ChartOptions<"bar"> = {
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
        max: 10,
      },
    },

    plugins: {
      title: {
        display: true,
        text: `   ${selection} MLI and Pain`,
        align: "start",
        padding: {
          top: 5,
          bottom: 15,
        },
      },
      legend: {
        display: false,
      },
    },
    animation: {
      onComplete: () => {
        if (typeof onRendered === "function") {
          onRendered();
        }
      },
    },
    // Additional options can be added here
  };

  // 99% apparent helps the resizing... https://stackoverflow.com/questions/57385938/how-to-get-react-chartjs-to-resize-back-down-with-window
  return (
    <div
      style={{
        height: height,
        width: "99%",
      }}
    >
      <Bar ref={ref} data={data} options={options} />
    </div>
  );
});

export default OverallBarChart;
